import * as actionTypes from "./actionTypes";

export const update = (items, total, unread) => ({
  type: actionTypes.UPDATE,
  items,
  total,
  unread
});

export const append = (items, total, unread) => ({
  type: actionTypes.APPEND,
  items,
  total,
  unread
});

export const updateOne = (item) => ({
  type: actionTypes.UPDATE_ONE,
  item,
});

export const loading = () => ({
  type: actionTypes.LOADING,
});

export const empty = () => ({
  type: actionTypes.EMPTY,
});
